__turbopack_context__.v({
  "detail-container": "SingleProduct8-module__qLMbUW__detail-container",
  "detail-content": "SingleProduct8-module__qLMbUW__detail-content",
  "parentIdText": "SingleProduct8-module__qLMbUW__parentIdText",
  "productSpecBox": "SingleProduct8-module__qLMbUW__productSpecBox",
  "specRow": "SingleProduct8-module__qLMbUW__specRow",
  "specTable": "SingleProduct8-module__qLMbUW__specTable",
  "specTitle": "SingleProduct8-module__qLMbUW__specTitle",
  "specTitleWrap": "SingleProduct8-module__qLMbUW__specTitleWrap",
  "specValue": "SingleProduct8-module__qLMbUW__specValue",
});
